export function padLeft(strtopad: string, num: number, padchar: string): string {
  // Pads Characters given the length num with character padchar
  return strtopad.length < num ? Array(num - String(strtopad).length + 1).join(padchar || '0') + strtopad : strtopad;
}

export function getOutputFrequencyAmplitude(systemClock: number, targetFrequency: number): number {
  const carrierAmplitude = (Math.PI * targetFrequency) / systemClock;
  return carrierAmplitude === 0 ? 0 : Math.abs(Math.sin(carrierAmplitude) / carrierAmplitude);
}

export function toFixedClean(value: number, precisionIn: number): string {
  const precision = precisionIn || 0,
    power = Math.pow(10, precision),
    absValue = Math.abs(Math.round(value * power));
  let result = (value < 0 ? '-' : '') + String(Math.floor(absValue / power));

  if (precision > 0) {
    const fraction = String(absValue % power),
      padding = new Array(Math.max(precision - fraction.length, 0) + 1).join('0');
    result += '.' + padding + fraction;
  }
  return result;
}

export function linearSpacing(startPoint: number, endPoint: number, stepCount: number): number[] {
  const stepDiff = (endPoint - startPoint) / stepCount;
  const stepList: number[] = [];
  for (let i = 0; i < stepCount; i++) {
    stepList.push(startPoint + stepDiff * i);
  }
  return stepList;
}

export function sigFigsDown(n: number, sig: number): number {
  const mult = Math.pow(10, sig - Math.floor(Math.log10(n)) - 1);
  return Math.trunc(n * mult) / mult;
}
